import { Button, FormControl, Grid, InputLabel, Modal, Select, Typography, makeStyles } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../context';
import { orderServices, productsServices } from '../services';
import SuccessIcon from '../icons/success';

const useStyles = makeStyles((theme) => ({
  modalStyle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "90%",  // Ajusta el ancho del modal para pantallas pequeñas
    maxWidth: 400, // Ancho máximo del modal
    backgroundColor: 'white',
    border: '2px solid #000',
    padding: theme.spacing(2, 4, 3),
    borderRadius: "15px",
    outline: "none",
    [theme.breakpoints.down("sm")]: {
      width: "95%", // Ajusta el ancho del modal para dispositivos medianos
    },
    [theme.breakpoints.down("xs")]: {
      width: "70%", // Ajusta el ancho del modal para dispositivos pequeños
      //top: "0",     // Ajusta la posición superior para dispositivos pequeños
      // transform: "translate(0%, 0%)", // Ajusta la transformación para dispositivos pequeños
      borderRadius: "0", // Sin bordes redondeados en dispositivos pequeños
    },
  },
  button: {
    backgroundColor: "#FFF",
    fontSize: "1rem",
    height: "auto",
    width: "200px",
    borderRadius: 16,
    textTransform: "none",
    color: theme.palette.secondary.main,
    border: `1px solid ${theme.palette.secondary.main}`,
    boxSizing: "border-box",
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
      color: "#FFF",
    },
    margin: "auto",  // Centra el botón horizontalmente
    display: "block",
    marginTop: "10px",
    [theme.breakpoints.down("sm")]: {
      width: "130px", // Ajusta el ancho del botón para dispositivos pequeños
    },
    [theme.breakpoints.down("xs")]: {
      width: "100px", // Ajusta el ancho del botón para dispositivos extra pequeños
      fontSize: "0.9rem", // Reduce el tamaño de la fuente para dispositivos extra pequeños
    },
  }
}));

export function EditProductStatusModal({ open, onClose, assigmentId, setOpenModal, getProducts }) {

  const classes = useStyles();
  const [state, setState] = useState('');
  const [productStatuses, setProductStatuses] = useState([]); // Estado para almacenar los estados de los productos
  const { authState, signOut } = useContext(AuthContext);
  const [openMessage, setOpenMessage] = useState(false);

  const getAllProductStatus = async () => {
    try {
      const response = await productsServices.getAllProductStatus({ token: authState.token });
      setProductStatuses(response.data);
    } catch (error) {
      console.error("Error al obtener los estados de las ordenes:", error);
    }
  };

  const updateProductStatus = async () => {
    const result = await productsServices.uploadProductStatus({ token: authState.token, productId: assigmentId, statusId: state });
    getProducts();
    setOpenMessage(result.message)
    setOpenModal(false)
  }

  useEffect(() => {
    getAllProductStatus();
  }, [authState.token]);

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className={classes.modalStyle}>
          <FormControl fullWidth>
            <InputLabel htmlFor="orders-status-select">Selecciona un estado</InputLabel>
            <Select
              native
              value={state}
              onChange={(e) => setState(e.target.value)}
              inputProps={{
                name: 'orders-status',
                id: 'orders-status-select',
              }}
            >
              <option aria-label="None" value="" />
              {productStatuses.map((status) => (
                <option key={status._id} value={status._id}>
                  {status.name}
                </option>
              ))}
            </Select>
            <Button
              className={classes.button}
              onClick={() => updateProductStatus()}
            >
              Editar estatus
            </Button>
          </FormControl>
        </div>
      </Modal>
      <Modal
        open={Boolean(openMessage)}
        onClose={() => setOpenMessage(false)}
      >
        <div className={classes.modalStyle}>
        <Grid container display="flex" direction="column" alignItems="center" justifty="center"  style={{ padding: "2rem 1rem", gap:"15px" }}>
          <Grid item>
            <SuccessIcon />
          </Grid>
          <Grid item style={{ margin: "auto 0" }}>
            <Typography style={{ fontWeight: "bold", fontSize: "1rem" }} align="center" color="primary">
              {openMessage}
            </Typography>
          </Grid>
          <Grid item>
            <Button
              fullWidth
              variant='contained'
              style={{backgroundColor:"#2196C0", textTransform:"none", color:"white"}}
              onClick={() => {
                setOpenMessage(false)
              }}
            >
              Aceptar
            </Button>
          </Grid>
          </Grid>
        </div>
      </Modal>
    </>
  );
}
